import React, { Component, useState } from "react";
// components
import PageTitle from "../../components/PageTitle/PageTitle";
import Cookies from "universal-cookie";
import LoadingOverlay from "react-loading-overlay";
import Table from "../../widgets/tables/Table";
import WaitDialog from "../../widgets/WaitDialog";

import SendMailWidget from "../../widgets/SendMailWidget";
import SendNotificationWidget from "../../widgets/SendNotificationWidget";
import GetInsegnanti from "../../services/getInsegnanti";
import DeleteInsegnante from "../../services/deleteInsegnante";
import Utils from "../../utils/utils";
import SelectPdfDatesWidget from "../../widgets/SelectPdfDatesWidget";
import FusioneWidget from "../../widgets/FusioneWidget";
import addGruppoInsegnanti from "../../services/addGruppoInsegnanti";
import deleteGruppoInsegnanti from "../../services/deleteGruppoInsegnanti";
import getGruppiInsegnanti from "../../services/getGruppiInsegnanti";
import addNotification from "../../services/addNotification";
import sendMail from "../../services/sendMail";
import getSetting from "../../services/getSetting";
import saveFile from "../../services/saveFile";
import addUtente from "../../services/addUtente";
import Button from "../../widgets/Button";
import generateExcel from "../../services/generateExcel";
import getPresenzeCorso from "../../services/getPresenzeCorso";
import getChiusura from "../../services/getChiusura";
import moment from "moment";
import getPresenze from "../../services/getPresenze";
import Constants from "../../utils/consts";
import getLezioni from "../../services/getLezioni";
import WaitDialogFileDownload from "../../widgets/WaitDialogFileDownload";
import getTariffeInsegnanti from "../../services/getTariffeInsegnanti";

export default class Insegnati extends React.Component {
	constructor(props) {
		super(props);

		this.pageDiv = {
			border: "1px solid #cccccc",
			padding: 10,
		};

		this.pageTitle = props.pageTitle;
		this.pageName = props.pageName;
		if (this.pageName == undefined) {
			this.pageName = this.section;
		}

		this.options = [{ value: "All", label: "All" }];

		this.selectRef = React.createRef();

		this.state = {
			testo: "",
			menuBackground: "#ffffff",
			menuItemColor: "#000000",
			fontSize: 50,
			fontBold: false,
			logoPicture: "",
			logoMargin: 0,
			titleColor: "#000000",
			titleSize: 18,
			isLoading: false,
			addElementVisible: false,
			waitDialogVisible: false,
			selectPdfDatesVisible: false,
			fusioneEnabled: false,
			insegnanti: [],
			gruppiInsegnantiComplete: [],
			mailCompaniesList: [],
			reportPeriod: "",
			waitDialogFileVisible: false,
			fileReady: false,
		};

		this.grid = 2;
		this.tableRef = React.createRef();

		this.pdfElements = [];

		this.insegnanti = [];
		this.gruppiInsegnantiComplete = [];
		this.pageTitle = "Insegnanti";
		this.brokerId = undefined;

		const cookies = new Cookies();
		var strJson = JSON.stringify({ list: [] });
		cookies.set("checksList", strJson, { path: "/" });
		this.sendMailRef = React.createRef();
		this.sendNotificationRef = React.createRef();

		this.state = {};
	}

	async reload() {
		const cookies = new Cookies();
		const username = cookies.get("username", { path: "/" });
		const token = cookies.get("token", { path: "/" });

		this.insegnanti = await GetInsegnanti(username, token);
		this.gruppiInsegnanti = await getGruppiInsegnanti(username, token);

		this.gruppiInsegnantiComplete = [];
		this.gruppiInsegnanti.forEach(i => {
			var splitted = i.insegnanti.split("---");
			var nomi = "";
			splitted.forEach(s => {
				if (s != "") {
					var val = this.insegnanti.find(i => i.id == s);
					if (val != undefined) {
						if (nomi.length > 1) nomi += ", ";
						nomi += val.cognome + " " + val.nome;
					}
				}
			});
			i._insegnanti = nomi;
			this.gruppiInsegnantiComplete.push(i);
		});

		this.setState({
			insegnanti: this.insegnanti,
			fusioneEnabled: false,
			gruppiInsegnantiComplete: this.gruppiInsegnantiComplete,
		});
	}

	async componentDidMount() {
		await this.reload();
	}

	render() {
		var headCells = [
			//  { id: '__', numeric: false, disablePadding: true, label: '' },
			{ id: "cognome", numeric: false, disablePadding: true, label: "Cognome" },
			{ id: "nome", numeric: false, disablePadding: true, label: "Nome" },
			{ id: "_", numeric: true, disablePadding: false, label: "" },
		];

		this.searchCols = ["nome", "cognome", "materie", "mail"];
		this.searchColsGroups = ["nome", "insegnanti"];

		const cookies = new Cookies();

		this.tableRef.current && this.tableRef.current.clearSearch();

		if (!this.state.gruppiInsegnantiComplete) return <div />;

		return (
			<div id={Math.random()}>
				<LoadingOverlay
					active={this.state.isLoading}
					styles={{
						content: base => ({
							position: "relative",
							width: "100%",
							top: "200px",
						}),
					}}
					spinner
					text={"Loading your content..."}
				>
					<PageTitle
						title={this.pageTitle}
						button="NUOVO"
						onClick={() => {
							window.location.href = "/#/app/addInsegnante";
						}}
						onSecondClick={() => {
							this.setState({
								fusioneEnabled: true,
							});
						}}
					/>

					<Table
						searchValue={""}
						id={Math.random()}
						headCells={headCells}
						searchCols={this.searchCols}
						rows={this.state.insegnanti}
						onEventClick={row => {
							cookies.set("currentInsegnante", row, { path: "/" });
							window.location.href = "/#/app/editInsegnante";
						}}
						onDelete={async id => {
							if (window.confirm("Sei sicuro di voler eliminare l'insegnante?") == false) return;

							const cookies = new Cookies();
							const username = cookies.get("username", { path: "/" });
							const token = cookies.get("token", { path: "/" });
							await DeleteInsegnante(username, token, id);
							this.reload();
						}}
						onElementCheck={async companyId => {
							const cookies = new Cookies();

							var json = cookies.get("checksList", { path: "/" });
							var checksList = json.list;
							var index = checksList.indexOf(companyId);
							if (index != -1) checksList.splice(index, 1);
							else checksList.push(companyId);

							cookies.set("checksList", JSON.stringify({ list: checksList }), { path: "/" });
						}}
					/>

					<WaitDialog show={this.state.waitDialogVisible} key={Math.random()} index={this.state.index} />
					<WaitDialogFileDownload
						onClose={() => this.setState({ waitDialogFileVisible: false })}
						show={this.state.waitDialogFileVisible}
						ready={this.state.fileReady}
						file={"https://" + Constants.mainUrl + "pdf/fatturazione.xlsx"}
						key={Math.random()}
						index={this.state.index}
					/>
				</LoadingOverlay>
			</div>
		);
	}
}
